// extracted by mini-css-extract-plugin
export default {"EditableStatus":"styles_EditableStatus__0X5ZD","title":"styles_title__du0Z4","content":"styles_content__0WdS4"};